<template>
  <el-card v-loading="loading" shadow="never">
    <div slot="header">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ name: $root.getDashboardPath() }">Dashboard</el-breadcrumb-item>
        <el-breadcrumb-item :to="{ name: 'Facilities' }">Facilities</el-breadcrumb-item>
        <el-breadcrumb-item v-if="facility" :to="{ name: 'Facility' }">{{String($root.state.facilityData.code).toUpperCase()}}</el-breadcrumb-item>
        <el-breadcrumb-item v-if="facility" :to="{ name: 'Facility Edit' }">{{String($root.state.facilityData.code).toUpperCase()}} Edit</el-breadcrumb-item>
        <el-breadcrumb-item v-else :to="{ name: 'Facility Create' }">Facility Create</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <el-form :model="form" :rules="rules" label-position="left" ref="facilityForm" label-width="150px">
      <el-form-item label="Title" prop="title"
        :rules="[
        { required: true, message: 'Please input title for facility', trigger: 'blur' },
        { type: 'string', message: 'Please input title for facility',
          trigger: ['blur', 'change'] }
        ]"
      >
        <el-input v-model="form.title"></el-input>
      </el-form-item>
      <el-form-item label="Code" prop="code"
        :rules="[
        { required: true, message: 'Please input code for facility', trigger: 'blur' },
        { type: 'string', message: 'Please input code for facility',
          trigger: ['blur', 'change'] }
        ]"
      >
        <el-input v-model="form.code" :disabled="!this.facility ? false : true"></el-input>
      </el-form-item>
      <el-form-item label="Facility Email" prop="email"
      >
        <el-input v-model="form.email"></el-input>
      </el-form-item>
      <el-form-item label="Accounting Email" prop="accountingEmail"
      >
        <el-input v-model="form.accountingEmail"></el-input>
      </el-form-item>
      <el-form-item label="Legal Name" prop="account"
        :rules="[
        { required: true, message: 'Please input account for facility', trigger: 'blur' },
        { type: 'string', message: 'Please input account for facility',
          trigger: ['blur', 'change'] }
        ]"
      >
        <el-input v-model="form.account"></el-input>
      </el-form-item>
      <el-form-item label="County" prop="county"
        :rules="[
        { required: true, message: 'Please enter county for facility', trigger: 'blur' },
        { type: 'string', message: 'Please enter county for facility',
          trigger: ['blur', 'change'] }
        ]"
      >
        <el-input v-model="form.county"></el-input>
      </el-form-item>
      <el-form-item label="Size" prop="size"
        :rules="[
        { required: true, message: 'Please input size for facility', trigger: 'blur' },
        { type: 'number', message: 'Please input size for facility',
          trigger: ['blur', 'change'] }
        ]"
      >
        <el-input v-model.number="form.size"></el-input>
      </el-form-item>
      <el-form-item label="Country" prop="addressInfo.country"
        :rules="[
        { required: true, message: 'Please select country', trigger: 'blur' },
        { type: 'string', message: 'Please select country',
          trigger: ['blur', 'change'] }
        ]"
      >
        <el-select
          v-model="form.addressInfo.country"
          placeholder="Select Country"
          size="small"
          style="width: 100%;"
          @change="() => resetStateAndPin()"
        >
          <el-option label="United States of America" value="us">
          </el-option>
          <el-option label="Canada" value="ca">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="Currency" prop="pricing.currency">
        <el-select placeholder="Select Currency" size="small" style="width: 100%;" v-model="form.pricing.currency">
          <el-option label="USD" value="usd"></el-option>
          <el-option label="CAD" value="cad"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="GST" prop="gst">
        <el-input v-model.number="form.gst"></el-input>
      </el-form-item>
      <el-form-item label="State" prop="addressInfo.state"
        :rules="[
        { required: true, message: 'Please input state', trigger: 'blur' },
        { type: 'string', message: 'Please input correct state',
          trigger: ['blur', 'change'] }
        ]"
      >
        <State
          :country="form.addressInfo.country"
          :given-state="form.addressInfo.state" @change="st => form.addressInfo.state = st"/>
      </el-form-item>
      <el-form-item
        :rules="[
        { required: true, message: 'Please input city', trigger: 'blur' },
        { type: 'string', message: 'Please input correct city',
          trigger: ['blur', 'change'] }
        ]"
        label="City"
        prop="addressInfo.city"
      >
        <el-input v-model="form.addressInfo.city" size="small" clearable></el-input>
      </el-form-item>
      <el-form-item
        :rules="[
        { required: true, message: 'Please input Address Line', trigger: 'blur' },
        { type: 'string', message: 'Please input correct Address Line',
          trigger: ['blur', 'change'] }
        ]"
        label="Address Line 1"
        prop="addressInfo.addressLine1"
      >
        <el-input v-model="form.addressInfo.addressLine1" size="small" clearable></el-input>
      </el-form-item>
      <el-form-item
        label="Address Line 2"
        prop="addressInfo.addressLine2"
      >
        <el-input v-model="form.addressInfo.addressLine2" size="small" clearable></el-input>
      </el-form-item>
      <el-form-item
        label="Post Code"
        prop="addressInfo.pinCode"
      >
        <el-input v-model="form.addressInfo.pinCode" size="small" clearable>
        </el-input>
      </el-form-item>
      <el-divider content-position="left">Manager Details</el-divider>
      <el-form-item label="Manager Name" prop="manager.name"
        :rules="[
        { required: true, message: 'Please input manager name for facility', trigger: 'blur' },
        { type: 'string', message: 'Please input manager name size for facility',
          trigger: ['blur', 'change'] }
        ]"
      >
        <el-input v-model="form.manager.name"></el-input>
      </el-form-item>
      <el-form-item label="Manager Email" prop="manager.email"
        :rules="[
        { required: true, message: 'Please input email address', trigger: 'blur' },
        { type: 'email', message: 'Please input correct email address',
          trigger: ['blur', 'change'] }
        ]"
      >
        <el-input v-model="form.manager.email"></el-input>
      </el-form-item>
      <el-form-item label="Manager Phone" prop="manager.phone"
        :rules="[
        { required: true, message: 'Please input phone', trigger: 'blur' },
        { type: 'string', message: 'Please input correct phone',
          trigger: ['blur', 'change'] }
        ]"
      >
        <el-input v-model="form.manager.phone"></el-input>
      </el-form-item>
      <el-divider content-position="left">Site Plan</el-divider>
      <el-form-item label="New Site Plan" prop="enableSceneSitePlan">
        <el-switch v-model="form.enableSceneSitePlan" active-text="Enabled" inactive-text="Disabled"></el-switch>
      </el-form-item>
      <el-divider content-position="left">Region Details</el-divider>
      <el-form-item label="Region" prop="region"
      >
        <el-select v-model="form.region" style="width: 100%;">
          <el-option v-for="region of regions" :key="region"
            :label="region"
            :value="region"
            placeholder="Select Region"
            size="small"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item
        label="Time Zone & offset"
      >
        <el-select :value="form.tz" @change="setTZ" style="width: 100%;">
          <el-option v-for="[tz, offset] of Object.entries(tzs)" :key="tz"
            :label="`${tz} ${Math.round(((offset / 60) * 100)) / 100}hrs`"
            :value="`${tz}:${offset}`"
            placeholder="Select TZ"
            size="small"
          >
          </el-option>
        </el-select>
      </el-form-item>

      <el-form-item>
        <el-button type="primary" @click="() => submitForm('facilityForm')">
          Save
        </el-button>
      </el-form-item>
    </el-form>
  </el-card>
</template>

<script>
import axios from 'axios';
import State from './Sate.vue';
import { ADMIN_API_BASE } from '../env';

export default {
  name: 'FacilityForm',
  props: { facility: { type: String, required: true } },
  components: { State },
  watch: {
    async facility() {
      this.loading = true;
      await this.getFacilityData();
      this.loading = false;
    },
  },
  async mounted() {
    this.loading = true;
    await this.getFacilityData();
    this.tzs = await this.getTzList();
    this.loading = false;
  },
  data() {
    const checkEmail = (rule, value, callback) => {
      if (value && value.endsWith('readyspaces.com')) {
        callback();
      }
      callback(new Error('Enter a valid Readyspaces Email.'));
    };
    const checkGst = (rule, value, callback) => {
      if (this.form.addressInfo.country === 'ca') {
        if (!value) {
          callback(new Error('GST required for CAN'));
        }
      }
      callback();
    };

    const checkZipCode = (rule, value, callback) => {
      const caRegExp = /^[A-Za-z]\d[A-Za-z][ -]?\d[A-Za-z]\d$/;
      const usRegExp = /(^\d{5}$)|(^\d{5}-\d{4}$)/;
      if (this.form.addressInfo.country === 'us') {
        if (usRegExp.test(value)) {
          callback();
        }
      } else if (this.form.addressInfo.country === 'ca') {
        if (caRegExp.test(value)) {
          callback();
        }
      }
      callback(new Error('Invalid Zip Code'));
    };

    return {
      loading: false,
      rules: {
        email: [
          { required: true, message: 'Please input email address for facility', trigger: 'blur' },
          { type: 'email', message: 'Please input email address for facility', trigger: ['blur', 'change'] },
          { validator: checkEmail, message: 'Please input a valid RS email' },
        ],
        accountingEmail: [
          { type: 'email', message: 'Add a valid email address for accounting', trigger: ['blur', 'change'] },
        ],
        'addressInfo.pinCode': [
          { validator: checkZipCode, trigger: ['blur', 'change'] },
          { required: true, message: 'Please input pin code', trigger: 'blur' },
        ],
        gst: [
          { validator: checkGst, trigger: ['blur', 'change'] },
        ],
      },
      tzs: {},
      regions: [
        'Pacific NW + Canada',
        'Northern California',
        'Southern California',
        'South',
        'East',
      ],
      form: {
        title: '',
        description: '',
        size: 0,
        address: '',
        addressInfo: {
          addressLine1: '',
          addressLine2: '',
          city: '',
          state: '',
          country: 'us',
          pinCode: null,
        },
        pricing: {
          currency: '',
        },
        county: '',
        email: '',
        tz: '',
        region: '',
        offset: 0,
        accountingEmail: '',
        manager: {
          name: '',
          email: '',
          phone: '',
        },
        gst: '',
        enableSceneSitePlan: false,
      },
    };
  },
  methods: {
    setTZ(value) {
      const [tz, offset] = value.split(':');
      this.form.tz = tz;
      this.form.offset = Number(offset);
    },
    resetStateAndPin() {
      this.form.pricing.currency = this.form.addressInfo.country === 'us' ? 'usd' : 'cad';
      this.form.addressInfo.state = null;
      this.form.addressInfo.pinCode = null;
    },
    routeToHomePage() {
      this.$router.push({ name: 'Facility', params: { facility: this.facility } });
    },
    async getFacilityData() {
      try {
        const facility = await axios.get(`${ADMIN_API_BASE}/facilities/${this.facility}`, {
          headers: {
            Authorization: `Bearer ${this.$keycloak.token}`,
          },
        });
        const { title, description, size, address, manager, account, code, addressInfo, email, county, accountingEmail, tz, offset, region, pricing, gst, enableSceneSitePlan } = facility.data;
        this.form = {
          title,
          description,
          size,
          address,
          email,
          county,
          pricing,
          manager: !manager ? {
            name: '',
            email: '',
            phone: '',
          } : { ...manager },
          addressInfo: !addressInfo ? {
            addressLine1: '',
            addressLine2: '',
            city: '',
            state: null,
            country: 'us',
            pinCode: null,
          } : { ...addressInfo },
          account,
          accountingEmail,
          code,
          tz,
          region,
          offset,
          gst,
          enableSceneSitePlan: !!enableSceneSitePlan,
        };
        this.loading = false;
      } catch (err) {
        this.loading = false;
        console.log(err);
      }
    },
    async getTzList() {
      const response = await axios.get(`${ADMIN_API_BASE}/tz/list`, {
        headers: {
          Authorization: `Bearer ${this.$keycloak.token}`,
        },
      });

      return response.data;
    },
    async submitForm(formName) {
      this.$refs[formName].validate(async (valid) => {
        if (valid) {
          this.loading = true;
          await this.saveFacilityDetails();
          this.loading = false;
          return true;
        }
        console.log('error submit!!');
        return false;
      });
    },
    async saveFacilityDetails() {
      try {
        if (!this.facility) {
          await axios.post(`${ADMIN_API_BASE}/facilities`, {
            ...this.form,
            description: this.form.account,
            createdBy: this.$keycloak.tokenParsed.email,
          },
          {
            headers: {
              Authorization: `Bearer ${this.$keycloak.token}`,
            },
          });

          this.$message.success({
            title: 'Success',
            message: 'Facility Added successfully!',
          });

          this.loading = false;
          this.$router.push({ name: 'Facilities' });
          return;
        }

        const result = await axios.post(`${ADMIN_API_BASE}/facilities/${this.facility}`, {
          ...this.form,
        },
        {
          headers: {
            Authorization: `Bearer ${this.$keycloak.token}`,
          },
        });

        this.$root.$data.setFacilityDataAction(result.data);

        this.$message.success({
          title: 'Success',
          message: 'Facility updated successfully!',
        });

        this.loading = false;
      } catch (err) {
        this.loading = false;
        this.$message.error({
          title: 'Error',
          message: err.response.data,
        });
        console.log(err);
      }
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/FacilityForm.vue